export const getEmailSettings = ({ settings: { emailSettings } }) => emailSettings;

export const getRequiredTempAgencyAgreements = (state) => state.requiredTempAgencyAgreements.items;

export const getInsuranceRequirementAgreements = (state) => state.insuranceRequirementAgreements.items;

export const getInsuranceRequirements = (state) => state.insuranceRequirements.items;

export const getTempPrerequisites = (state) => state.tempPrerequisites.items;
